import { useCallback } from 'react';
import { Task } from 'api/tasks';
import { TaskListItem } from 'components/organisms/timesheets/drawers/add-tasks';
import { CurrentUserProfileSliceState } from 'data/current-user-profile/slice';

const useIsTaskAssignedToCurrentUser = (currentUserProfile) => {
  return useCallback(
    (_task: Task | TaskListItem): boolean => {
      const _userId = currentUserProfile?.user.userId;

      return (
        _task.assignee?.users.some((user) => user.userId === _userId) ?? false
      );
    },
    [currentUserProfile],
  );
};

export const useTaskListItems = <T extends Task | TaskListItem>(
  currentUserProfile: CurrentUserProfileSliceState,
) => {
  const isTaskAssignedToCurrentUser =
    useIsTaskAssignedToCurrentUser(currentUserProfile);

  return useCallback(
    (_taskList: T[], getMyTasks: boolean): T[] =>
      _taskList.filter((task) =>
        getMyTasks
          ? isTaskAssignedToCurrentUser(task)
          : !isTaskAssignedToCurrentUser(task),
      ),
    [isTaskAssignedToCurrentUser],
  );
};
